import styled from 'styled-components';
import { Button, Form } from '@bynder/design-system';

export const DropdownButton = styled(Button)`
    justify-content: flex-start;

    & div:last-child {
        margin-left: auto;
    }
`;

export const RowStyled = styled(Form.Row)`
    grid-template-columns: minmax(10px, 1fr) 24px minmax(10px, 1fr);
    align-items: center;
`;
